import { render, staticRenderFns } from "./Signals.vue?vue&type=template&id=608615f4&"
import script from "./Signals.vue?vue&type=script&lang=js&"
export * from "./Signals.vue?vue&type=script&lang=js&"
import style0 from "./Signals.vue?vue&type=style&index=0&id=608615f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports